import React, { Fragment } from 'react'
import styles from './forgot-password.styles'
import injectSheet from 'react-jss'
import Wrapper from '../../wrapper/wrapper'
import Container from '../../container/container'
import Description from '../../description/description'
import Footer from '../../footer/footer'
import duckFixer from './duck-fixer.gif'
import { Link } from 'react-router-dom'
import CarretLeft from 'react-icons/lib/fa/caret-left'
import ForgotPasswordForm from './forgot-password-form/forgot-password-form.container'
import Auth from '../../auth/auth'

const ForgotPassword = ({ classes, showSuccessScreen }) => (
  <Auth>
    <Wrapper>
      <Container primary img={duckFixer}>
        {showSuccessScreen && (
          <Description noBorder title="Please check your email">
            <p>
              We've emailed you a link,
              <br />
              so you can update your password.
            </p>
          </Description>
        )}
        {!showSuccessScreen && (
          <Fragment>
            <Description title="Forgotten your password?">
              <p>
                Forgotten your password or re-send your account activation link?
                Enter your email and we’ll help you out
              </p>
              <Link to="/" className={classes.backLink}>
                <CarretLeft /> Back to sign in
              </Link>
            </Description>
            <ForgotPasswordForm />
          </Fragment>
        )}
        <Footer>
          <span className={classes.newToPobble}>New to pobble?</span>
          <Link to="/sign-up">Sign up here</Link>
        </Footer>
      </Container>
    </Wrapper>
  </Auth>
)

export default injectSheet(styles)(ForgotPassword)
